import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "goods-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_input = _resolveComponent("el-input");
    const _component_Goods = _resolveComponent("Goods");
    return _openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
                class: "add-item",
                onClick: _cache[1] || (_cache[1] = (...args)=>$options.choose && $options.choose(...args))
            }, [
                _createVNode(_component_el_input, {
                    modelValue: $data.value.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.value.title = $event),
                    placeholder: "请选择课程商品"
                }, null, 8, [
                    "modelValue"
                ])
            ])
        ]),
        $data.dialog.save ? (_openBlock(), _createBlock(_component_Goods, {
            key: 0,
            ref: "GoodsDialog",
            onSuccess: $options.handleSuccess,
            onClosed: _cache[2] || (_cache[2] = ($event)=>$data.dialog.save = false)
        }, null, 8, [
            "onSuccess"
        ])) : _createCommentVNode("", true)
    ], 64);
}
